// extracted by mini-css-extract-plugin
module.exports = {"teamsListGridItem":"Teams_teamsListGridItem__2XJQ4"};